import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { IBurgerMenuItem } from 'API/Home/burgerMenuItems';

export interface IBurgerMenuState {
  menuItems: IBurgerMenuItem[];
}

const initialState: IBurgerMenuState = {
  menuItems: [],
};

export const menuItemsSlice = createSlice({
  name: 'menu-items',
  initialState,
  reducers: {
    setMenuItems: (
      state: IBurgerMenuState,
      action: PayloadAction<IBurgerMenuState | any>
    ) => {
      state.menuItems = action.payload;
    },
  },
});

export const { setMenuItems } = menuItemsSlice.actions;
export default menuItemsSlice.reducer;
